import styled from "styled-components";
import { Breadcrumb, Button, Layout, Space } from "antd";
import { ReactComponent as BackButtonIcon } from "../../assets/icons/BackButton.svg";

export const DietLayout = styled(Layout)`
  padding: 1.5rem 2.25rem;
  background-color: transparent;
`;

export const Header = styled(Layout)`
  background-color: transparent;
  margin-bottom: 10px;
`;

export const StyledSpace = styled(Space)`
  display: flex;
  align-items: center;

  .ant-space-item:not(:first-child) {
    width: 100%;
    display: flex;
  }
`;

export const BackButton = styled(Button)`
  width: 2rem;
  height: 2rem;
  border: 0;
  outline: none;
  box-shadow: none;
  background-color: transparent;

  &:hover {
    outline: none;
    box-shadow: none;
  }

  &:active {
    outline: none;
    box-shadow: none;
  }
`;

export const StyledBackButtonIcon = styled(BackButtonIcon)`
  width: 24px;
  height: 24px;
`;